import React, { createContext, useContext, useState } from "react";

export const FILTER_MENU = {
  employeeId: [], //"",
  courseId: [], //"",
  epmrNumber: "",
  paymentMode: [],
  businessAreaId: [],
  status: [],
  receiptDateFrom: "",
  receiptDateTo: "",
};
export const FILTER__FORM_FIELDS_GLOBAL = {
  // searchField: "psid",
  psid: "",
  studentName: "",
  ...FILTER_MENU,
};

export const EPMRContext = createContext({
  //   currentPageState: "SEARCH_RECEIPT",
  //   setCurrentPageState: () => {},
  globalFilter: {},
  setGlobalFilter: () => {},
});

export const EPMRProvider = ({ children, ...props }) => {
  const [globalFilter, setGlobalFilter] = useState({
    ...FILTER__FORM_FIELDS_GLOBAL,
  });

  const [dropdownOptions, setDropdownOptions] = useState({
    paymode: [],
  });
  const [filterCount, setFilterCount] = useState(0);

  const [buDescriptionMap, setBuDescriptionMap] = useState({});
  const [courseTermMap, setCourseTermMap] = useState({});
  const [remarksMap, setRemarksMap] = useState({});

  return (
    <EPMRContext.Provider
      value={{
        globalFilter,
        setGlobalFilter,

        dropdownOptions,
        setDropdownOptions,

        filterCount,
        setFilterCount,

        buDescriptionMap,
        setBuDescriptionMap,
        courseTermMap,
        setCourseTermMap,
        remarksMap,
        setRemarksMap,
      }}
    >
      {children}
    </EPMRContext.Provider>
  );
};
